/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * OpenAPI definition
 * OpenAPI spec version: v0
 */
import type {
  AssociationBoardMembershipCreateRequest,
  AssociationBoardMembershipUpdateRequest,
  AssociationMembershipCreateRequest,
  AssociationMembershipResponse,
  AssociationMembershipUpdateRequest,
  BoardRoleUpdateRequest,
  DeleteMembershipResponse,
  ImportMembershipsBody,
  UpdateMembersToManageUsersResponse
} from '../../../schemas';

import { customFetch } from '../../../../custom-fetcher';
import { customFormDataFn } from '../../../../custom-formdata';

export type updateMembershipResponse200 = {
  data: void
  status: 200
}

export type updateMembershipResponseSuccess = (updateMembershipResponse200) & {
  headers: Headers;
};
;

export type updateMembershipResponse = (updateMembershipResponseSuccess)

export const getUpdateMembershipUrl = (id: string,) => {




  return `/api/v1/association-memberships/members/${id}`
}

export const updateMembership = async (id: string,
    associationMembershipUpdateRequest: AssociationMembershipUpdateRequest, options?: RequestInit): Promise<updateMembershipResponse> => {

  return customFetch<updateMembershipResponse>(getUpdateMembershipUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(associationMembershipUpdateRequest)
  }
);}


export type deleteMembershipResponse204 = {
  data: void
  status: 204
}

export type deleteMembershipResponseSuccess = (deleteMembershipResponse204) & {
  headers: Headers;
};
;

export type deleteMembershipResponse = (deleteMembershipResponseSuccess)

export const getDeleteMembershipUrl = (id: string,) => {




  return `/api/v1/association-memberships/members/${id}`
}

export const deleteMembership = async (id: string, options?: RequestInit): Promise<deleteMembershipResponse> => {

  return customFetch<deleteMembershipResponse>(getDeleteMembershipUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}


export type updateMemberToManageUsersResponse200 = {
  data: void
  status: 200
}

export type updateMemberToManageUsersResponseSuccess = (updateMemberToManageUsersResponse200) & {
  headers: Headers;
};
;

export type updateMemberToManageUsersResponse = (updateMemberToManageUsersResponseSuccess)

export const getUpdateMemberToManageUsersUrl = (id: string,) => {




  return `/api/v1/association-memberships/members/${id}/roles/manage-users`
}

export const updateMemberToManageUsers = async (id: string, options?: RequestInit): Promise<updateMemberToManageUsersResponse> => {

  return customFetch<updateMemberToManageUsersResponse>(getUpdateMemberToManageUsersUrl(id),
  {
    ...options,
    method: 'PUT'


  }
);}


export type updateManageUsersToAdminResponse200 = {
  data: void
  status: 200
}

export type updateManageUsersToAdminResponseSuccess = (updateManageUsersToAdminResponse200) & {
  headers: Headers;
};
;

export type updateManageUsersToAdminResponse = (updateManageUsersToAdminResponseSuccess)

export const getUpdateManageUsersToAdminUrl = (id: string,) => {




  return `/api/v1/association-memberships/members/${id}/roles/admin`
}

export const updateManageUsersToAdmin = async (id: string,
    boardRoleUpdateRequest?: BoardRoleUpdateRequest, options?: RequestInit): Promise<updateManageUsersToAdminResponse> => {
    const formData = customFormDataFn(boardRoleUpdateRequest)
  return customFetch<updateManageUsersToAdminResponse>(getUpdateManageUsersToAdminUrl(id),
  {
    ...options,
    method: 'PUT'
    ,
    body: formData
  }
);}


export type updateMembersToManageUsersResponse200 = {
  data: UpdateMembersToManageUsersResponse
  status: 200
}

export type updateMembersToManageUsersResponseSuccess = (updateMembersToManageUsersResponse200) & {
  headers: Headers;
};
;

export type updateMembersToManageUsersResponse = (updateMembersToManageUsersResponseSuccess)

export const getUpdateMembersToManageUsersUrl = () => {




  return `/api/v1/association-memberships/members/roles/manage-users`
}

export const updateMembersToManageUsers = async (updateMembersToManageUsersBody: string[], options?: RequestInit): Promise<updateMembersToManageUsersResponse> => {

  return customFetch<updateMembersToManageUsersResponse>(getUpdateMembersToManageUsersUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateMembersToManageUsersBody)
  }
);}


export type revokeBoardMembershipResponse200 = {
  data: void
  status: 200
}

export type revokeBoardMembershipResponseSuccess = (revokeBoardMembershipResponse200) & {
  headers: Headers;
};
;

export type revokeBoardMembershipResponse = (revokeBoardMembershipResponseSuccess)

export const getRevokeBoardMembershipUrl = (associationId: string,
    memberId: string,) => {




  return `/api/v1/association-memberships/by-association/${associationId}/members/${memberId}/roles/admin/revoke`
}

export const revokeBoardMembership = async (associationId: string,
    memberId: string, options?: RequestInit): Promise<revokeBoardMembershipResponse> => {

  return customFetch<revokeBoardMembershipResponse>(getRevokeBoardMembershipUrl(associationId,memberId),
  {
    ...options,
    method: 'PUT'


  }
);}


export type resignBoardMembershipResponse200 = {
  data: void
  status: 200
}

export type resignBoardMembershipResponseSuccess = (resignBoardMembershipResponse200) & {
  headers: Headers;
};
;

export type resignBoardMembershipResponse = (resignBoardMembershipResponseSuccess)

export const getResignBoardMembershipUrl = (associationId: string,) => {




  return `/api/v1/association-memberships/by-association/${associationId}/members/me/roles/admin/resign`
}

export const resignBoardMembership = async (associationId: string, options?: RequestInit): Promise<resignBoardMembershipResponse> => {

  return customFetch<resignBoardMembershipResponse>(getResignBoardMembershipUrl(associationId),
  {
    ...options,
    method: 'PUT'


  }
);}


export type updateBoardMembershipResponse200 = {
  data: void
  status: 200
}

export type updateBoardMembershipResponseSuccess = (updateBoardMembershipResponse200) & {
  headers: Headers;
};
;

export type updateBoardMembershipResponse = (updateBoardMembershipResponseSuccess)

export const getUpdateBoardMembershipUrl = (id: string,) => {




  return `/api/v1/association-memberships/board-members/${id}`
}

export const updateBoardMembership = async (id: string,
    associationBoardMembershipUpdateRequest: AssociationBoardMembershipUpdateRequest, options?: RequestInit): Promise<updateBoardMembershipResponse> => {

  return customFetch<updateBoardMembershipResponse>(getUpdateBoardMembershipUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(associationBoardMembershipUpdateRequest)
  }
);}


export type createMembershipResponse201 = {
  data: void
  status: 201
}

export type createMembershipResponseSuccess = (createMembershipResponse201) & {
  headers: Headers;
};
;

export type createMembershipResponse = (createMembershipResponseSuccess)

export const getCreateMembershipUrl = () => {




  return `/api/v1/association-memberships/member`
}

export const createMembership = async (associationMembershipCreateRequest: AssociationMembershipCreateRequest, options?: RequestInit): Promise<createMembershipResponse> => {

  return customFetch<createMembershipResponse>(getCreateMembershipUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(associationMembershipCreateRequest)
  }
);}


export type importMembershipsResponse201 = {
  data: void
  status: 201
}

export type importMembershipsResponseSuccess = (importMembershipsResponse201) & {
  headers: Headers;
};
;

export type importMembershipsResponse = (importMembershipsResponseSuccess)

export const getImportMembershipsUrl = () => {




  return `/api/v1/association-memberships/import-members`
}

export const importMemberships = async (importMembershipsBody?: ImportMembershipsBody, options?: RequestInit): Promise<importMembershipsResponse> => {
    const formData = customFormDataFn(importMembershipsBody)
  return customFetch<importMembershipsResponse>(getImportMembershipsUrl(),
  {
    ...options,
    method: 'POST'
    ,
    body: formData
  }
);}


export type createBoardMembershipResponse201 = {
  data: void
  status: 201
}

export type createBoardMembershipResponseSuccess = (createBoardMembershipResponse201) & {
  headers: Headers;
};
;

export type createBoardMembershipResponse = (createBoardMembershipResponseSuccess)

export const getCreateBoardMembershipUrl = () => {




  return `/api/v1/association-memberships/board`
}

export const createBoardMembership = async (associationBoardMembershipCreateRequest: AssociationBoardMembershipCreateRequest, options?: RequestInit): Promise<createBoardMembershipResponse> => {

  return customFetch<createBoardMembershipResponse>(getCreateBoardMembershipUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(associationBoardMembershipCreateRequest)
  }
);}


export type findByIdResponse200 = {
  data: AssociationMembershipResponse
  status: 200
}

export type findByIdResponseSuccess = (findByIdResponse200) & {
  headers: Headers;
};
;

export type findByIdResponse = (findByIdResponseSuccess)

export const getFindByIdUrl = (id: string,) => {




  return `/api/v1/association-memberships/${id}`
}

export const findById = async (id: string, options?: RequestInit): Promise<findByIdResponse> => {

  return customFetch<findByIdResponse>(getFindByIdUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}


export type downloadCsvTemplateResponse200 = {
  data: string
  status: 200
}

export type downloadCsvTemplateResponseSuccess = (downloadCsvTemplateResponse200) & {
  headers: Headers;
};
;

export type downloadCsvTemplateResponse = (downloadCsvTemplateResponseSuccess)

export const getDownloadCsvTemplateUrl = () => {




  return `/api/v1/association-memberships/import-template`
}

export const downloadCsvTemplate = async ( options?: RequestInit): Promise<downloadCsvTemplateResponse> => {

  return customFetch<downloadCsvTemplateResponse>(getDownloadCsvTemplateUrl(),
  {
    ...options,
    method: 'GET'


  }
);}


export type exportAsCsvResponse200 = {
  data: string
  status: 200
}

export type exportAsCsvResponseSuccess = (exportAsCsvResponse200) & {
  headers: Headers;
};
;

export type exportAsCsvResponse = (exportAsCsvResponseSuccess)

export const getExportAsCsvUrl = (associationId: string,) => {




  return `/api/v1/association-memberships/export/${associationId}`
}

export const exportAsCsv = async (associationId: string, options?: RequestInit): Promise<exportAsCsvResponse> => {

  return customFetch<exportAsCsvResponse>(getExportAsCsvUrl(associationId),
  {
    ...options,
    method: 'GET'


  }
);}


export type findAllByAssociationIdResponse200 = {
  data: AssociationMembershipResponse[]
  status: 200
}

export type findAllByAssociationIdResponseSuccess = (findAllByAssociationIdResponse200) & {
  headers: Headers;
};
;

export type findAllByAssociationIdResponse = (findAllByAssociationIdResponseSuccess)

export const getFindAllByAssociationIdUrl = (associationId: string,) => {




  return `/api/v1/association-memberships/by-association/${associationId}`
}

export const findAllByAssociationId = async (associationId: string, options?: RequestInit): Promise<findAllByAssociationIdResponse> => {

  return customFetch<findAllByAssociationIdResponse>(getFindAllByAssociationIdUrl(associationId),
  {
    ...options,
    method: 'GET'


  }
);}


export type findByAccountAndAssociationIdResponse200 = {
  data: AssociationMembershipResponse
  status: 200
}

export type findByAccountAndAssociationIdResponseSuccess = (findByAccountAndAssociationIdResponse200) & {
  headers: Headers;
};
;

export type findByAccountAndAssociationIdResponse = (findByAccountAndAssociationIdResponseSuccess)

export const getFindByAccountAndAssociationIdUrl = (associationId: string,) => {




  return `/api/v1/association-memberships/by-association/${associationId}/membership`
}

export const findByAccountAndAssociationId = async (associationId: string, options?: RequestInit): Promise<findByAccountAndAssociationIdResponse> => {

  return customFetch<findByAccountAndAssociationIdResponse>(getFindByAccountAndAssociationIdUrl(associationId),
  {
    ...options,
    method: 'GET'


  }
);}


export type findAllByAccountResponse200 = {
  data: AssociationMembershipResponse[]
  status: 200
}

export type findAllByAccountResponseSuccess = (findAllByAccountResponse200) & {
  headers: Headers;
};
;

export type findAllByAccountResponse = (findAllByAccountResponseSuccess)

export const getFindAllByAccountUrl = () => {




  return `/api/v1/association-memberships/by-account`
}

export const findAllByAccount = async ( options?: RequestInit): Promise<findAllByAccountResponse> => {

  return customFetch<findAllByAccountResponse>(getFindAllByAccountUrl(),
  {
    ...options,
    method: 'GET'


  }
);}


export type deleteMembershipsResponse200 = {
  data: DeleteMembershipResponse
  status: 200
}

export type deleteMembershipsResponseSuccess = (deleteMembershipsResponse200) & {
  headers: Headers;
};
;

export type deleteMembershipsResponse = (deleteMembershipsResponseSuccess)

export const getDeleteMembershipsUrl = () => {




  return `/api/v1/association-memberships/members`
}

export const deleteMemberships = async (deleteMembershipsBody: string[], options?: RequestInit): Promise<deleteMembershipsResponse> => {

  return customFetch<deleteMembershipsResponse>(getDeleteMembershipsUrl(),
  {
    ...options,
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(deleteMembershipsBody)
  }
);}


